export default __webpack_public_path__ + "static/instance04-9f7ee89af0293163113c7dc3383e3361.png";